import { Component } from '@grafikr/components';

export default Component((node) => {
  const messageEl = node.querySelector<HTMLElement>('[data-cart-toast-message]')!;
  const messageTemplate = node.dataset.message ?? '';
  const boldTitle = node.hasAttribute('data-bold-title');
  const duration = (Number(node.dataset.duration) || 3) * 1000;
  let hideTimeout: ReturnType<typeof setTimeout>;

  const show = (title: string, autoHide = true) => {
    clearTimeout(hideTimeout);

    if (boldTitle) {
      const [before = '', after = ''] = messageTemplate.split('%%TITLE%%');
      const strong = document.createElement('strong');
      strong.textContent = title;
      messageEl.replaceChildren(document.createTextNode(before), strong, document.createTextNode(after));
    } else {
      messageEl.textContent = messageTemplate.replace('%%TITLE%%', title);
    }

    requestAnimationFrame(() => {
      node.classList.add('translate-y-0');
      node.classList.remove('-translate-y-full');
    });

    if (autoHide) {
      hideTimeout = setTimeout(hide, duration);
    }
  };

  const hide = () => {
    node.classList.remove('translate-y-0');
    node.classList.add('-translate-y-full');
  };

  document.addEventListener('cart:added', (event) => {
    const data = event.detail;
    const title = 'items' in data ? data.items[0]?.product_title : data.product_title;
    if (title) show(title);
  });

  if (Shopify.designMode) {
    const section = node.closest('.shopify-section');

    if (section) {
      section.addEventListener('shopify:section:select', () => {
        show('Example product', false);
      });

      section.addEventListener('shopify:section:deselect', () => {
        hide();
      });
    }
  }
});
